export default {
  // Endpoints
  loginEndpoint: '/internal/auth/login',
  getProfileEndpoint: '/internal/account/profile',
  getPrivilegeEndpoint: '/internal/account/privilege',
  getPrivilegePlatformEndpoint: '/internal/account/privilege-platform',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',

  Endpoint: '/internal/',
  EndpointInternal: '/',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
